import { Node, NodePositionChange } from "@xyflow/react";
import { RefObject } from "react";

/** Create a new array of nodes with updated positions */
export default function updateNodePositions(
  nodes: Node[],
  nodeChangesRef: RefObject<Map<string, NodePositionChange>>,
) {
  return nodes.map((node) => {
    if (nodeChangesRef.current) {
      // Look up the nodeChange for this node by id
      const nodeChange = nodeChangesRef.current.get(node.id);

      // If a matching nodeChange is found, update the node's position
      if (nodeChange) {
        return {
          ...node,
          position: nodeChange.position,
          positionAbsolute: nodeChange.positionAbsolute,
        };
      }
    }

    return node;
  });
}
